import React from "react";

const ChatBubbleRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 12,
  height: 11,
  viewBox: "0 0 12 11",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 10.3448C8.89655 10.3448 12 8.89655 12 5.17241C12 1.44828 8.89655 0 6 0C3.10345 0 0 1.44828 0 5.17241C0 6.02466 0.16253 6.75774 0.447915 7.38149C0.625804 7.77037 0.725586 8.19915 0.646792 8.61939L0.429799 9.77669C0.322544 10.3487 0.823672 10.8499 1.39573 10.7426L4.05011 10.2449C4.25876 10.2058 4.47269 10.2092 4.68232 10.2425C5.11862 10.3116 5.56171 10.3448 6 10.3448Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ChatBubbleRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;